import React, { useContext, useState } from 'react';

import { Typography, Grid, Theme, Button, IconButton } from '@material-ui/core';

import { Helmet } from 'react-helmet';

import { useHistory, useLocation } from 'react-router-dom';

import {
  ShowCase,
  Story,
  OfferCard,
  LoginForm,
  SignupForm,
} from '../../../components';
import { UserContext } from "../../../context/UserProvider";
import CoronaImg from '../../../assets/svg/coroana.svg';
import WomanImg from '../../../assets/svg/womenWithLab.svg';
import TeamIcon1 from '../../../assets/ourTeam_1st.png';
import TeamIcon2 from '../../../assets/ourTeam_2d.png';
import TeamIcon3 from '../../../assets/ourTeam_3d.png';
import Vaccine from '../../../assets/vaccine.png';
import IVTherapyImg from '../../../assets/IVTherapy.jpg';
import FeelBetter from '../../../assets/FeelBetter.jpg';

import { makeStyles, createStyles } from '@material-ui/core';
import Banner from '../../../components/Banner';
import { ExpandLess, ExpandMore, Height } from '@material-ui/icons';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    faqSection: {
      padding: '40px 0',
      overflowX: 'hidden',
      margin:"0 100px",
    },
    faqTitle: {
      marginBottom: '20px',
      fontSize:"24px",
      textAlign: 'left',
      fontWeight: 900,
    },
    faqSubTitle: {
      marginBottom: '10px',
      textAlign: 'left',
      fontWeight: 'bold',
      color: '#AD131B',
    },
    questionWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '15px',
      cursor: 'pointer', 
      borderBottom: '1px solid #ddd', 
      transition: 'background-color 0.3s ease',
    }, expandedQuestion: {
      backgroundColor: '#FFECEC', 
      borderRadius: '5px',
    },
    answerText: {
      marginTop: '10px',
      fontSize: '16px',
      color: '#555',
    },

    ourTeamSection: {
      paddingTop: "0px",
      padding: "7rem 0",
      [theme.breakpoints.down("xs")]: {
        padding: "1rem",
        marginTop: "2rem",
      },
    },
    MUILimition: {
      padding: "40px",
    },
    title: {
      textAlign: "center",
    },
    centerText: {
      textAlign: "center",
    },
    ourTeamCardItem: {
      [theme.breakpoints.down("sm")]: {
        marginBottom: "2rem",
      },
    },
    ourTeamCardTitle: {
      fontSize: "21px",
      color: theme.palette.primary.dark,
    },
    ourTeamCardDesc: {
      fontSize: "16px",
      color: theme.palette.primary.dark,
    },
    titleWrapper: {
      marginBottom: "6rem",
    },
  
     FeelBetterSection: {
  paddingTop: "80px",
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  alignItems: "center",
  height: "400px",
  width: "100%",
  position: "relative",
  background: `url(${FeelBetter}) no-repeat bottom center`,
  backgroundSize: "cover", 
  backgroundPosition: "bottom", 
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: to add overlay
    zIndex: 1,
  },
},

  choseClincSection: {
      paddingTop: "100px",
      display: "flex",
      flexDirection: "column", // Stack elements for small screens
      textAlign: "center",
      alignItems: "center",
      height: "800px",
      width: "100%",
      position: "relative",
      background: `url(${IVTherapyImg}) no-repeat center center/cover`,
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1,
      },
      [theme.breakpoints.down("sm")]: {
        height: "auto", // Allow content to fit on smaller screens
        paddingTop: "50px",
      },
    },
    titleIVsec: {
      margin: "0 100px",
      marginTop: "110px",
      color: "#FFFFFF",
      fontSize: "24px",
      fontWeight: 700,
      zIndex: 2,
      [theme.breakpoints.down("sm")]: {
        margin: "0 20px", // Reduce margin on smaller screens
        fontSize: "20px", // Adjust font size for mobile
        marginTop: "80px", // Adjust margin-top for mobile
      },
    },
    choseClincSectionDesc: {
      fontSize: "56px",
      fontWeight: 900,
      color: "#FFFFFF",
      zIndex: 2,
      [theme.breakpoints.down("sm")]: {
        fontSize: "25px", // Reduce font size for mobile
        margin: "0 20px", // Adjust margin for mobile
      },
    },
    IVDesc: {
      margin: "30px 150px",
      fontSize: "16px",
      fontWeight: 400,
      color: "#FFFFFF",
      zIndex: 2,
      [theme.breakpoints.down("sm")]: {
        margin: "20px 10px", // Adjust margin for mobile
        fontSize: "14px", // Reduce font size for mobile
      },
    },
    IVDescBold: {
      margin: "0 150px",
      fontSize: "16px",
      fontWeight: 600,
      color: "#FFFFFF",
      zIndex: 2,
      [theme.breakpoints.down("sm")]: {
        margin: "0 30px", // Adjust margin for mobile
        fontSize: "14px", // Reduce font size for mobile
      },
    },
    banner: {
      margin: "0 auto",
      maxWidth: "70%",
      marginBottom: "60px",
      [theme.breakpoints.down("xs")]: {
        maxWidth: "95%",
      },
    },
        ivTherapySection: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: '#f5f5f5',
      alignItems: 'center',
      padding: '50px 0',
      [theme.breakpoints.down('sm')]: {
         flexDirection: 'column-reverse', 
        Height:"800px",
        
        textAlign: 'center',
        padding: '0px 0',
      },
    },
        ivTextSection: {
        marginLeft: '100px',
        flex: 1,
        paddingRight: '20px',
        [theme.breakpoints.down('sm')]: {
        paddingRight: '0',
        marginLeft:"0px",
      },
    },
    ivImportantDescription: {
      fontWeight: 'bold',
    },
    ivTitle: {
      fontSize: '32px',
      fontWeight: 700,
      marginBottom: '20px',
    },
    ivDescription: {
      fontSize: '18px',
      lineHeight: '1.8',
      color: '#000',
    },
    ivImageSection: {
      flex: 1,
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        marginTop: '120px',
      },
    },
    ivImage: {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '8px',
       [theme.breakpoints.down('sm')]: {
        width: '80%',
      },
    },sectionGradiant:{
        background: `linear-gradient(to top left, rgba(173, 19, 27, 0.05), rgba(173, 19, 27, 0))`,
    },
     sectionTitle: {
        marginTop: '50px',
      textAlign: 'center',    },
    sectionSubtitle: {
      textAlign: 'center',
      fontSize: '20px',
      marginBottom: '20px',
    },
    cardContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: '50px 100px',
      justifyContent: 'space-between',
      gap: '20px',
         [theme.breakpoints.down('sm')]: {
          padding: '5px 10px',
      },  
    },
    card: {
      display: 'flex',
      flexDirection: 'row',
      width: '48%',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
      padding: '20px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        width: '100%',
      },
    },
    cardImage: {
      width: '33%',
      height: 'auto',
      borderRadius: '8px',
    },
    cardContent: {
      paddingLeft: '20px',
      flex: 1,
    },
    cardTitle: {
      fontWeight:900,
      fontSize: '22px',
      color: '#000',
    },
    cardPrice: {
      fontSize: '16px',
      color: '#AD131B',
      fontWeight: 'bold',
    },
    cardDescription: {
      marginTop: '10px',
      fontWeight:600,
      fontSize: '14px',
    },
    cardSpan: {
      fontWeight: 300,
      color:"#4E4E4E",
    },
    cardButton: {
      zIndex: 2,
      marginTop: '20px',
      borderRadius: '25px',
      padding: '10px 20px',  
      textTransform: 'capitalize',
      backgroundColor: '#AD131B',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#9B0E1A',
      },
    },
     section: {
      backgroundColor: '#AD2320',
      color: '#FFFFFF',
      padding: '50px 70px',
      [theme.breakpoints.down('sm')]: {
        padding: '30px 0',
      },
    },
    secTitle: {
      fontSize: '32px',
      fontWeight: 900,
      marginBottom: '20px',
      textAlign: 'left',
    },
    description: {
      
      fontSize: '16px',
      fontWeight: 500,
      listStyleType: 'disc',
      lineHeight: '1.8',

      
      color: '#FFFFFF',
      fontFamily: '"Roboto", sans-serif',
    },
    sectionContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        textAlign: 'center',
      },
    },
    leftColumn: {
      flex: 1,
      // Adjusted for larger screens
      paddingLeft: '50px',
      [theme.breakpoints.down('sm')]: {
        paddingRight: '0', // Stack the text in smaller screens
        paddingLeft: '0',
        textAlign: 'center',
      },
    },
    rightColumn: {
      flex: 1,
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        marginTop: '20px',
      },
    },
    image: {
      width: '70%',
      height: 'auto',
      marginTop: '-90px',
      marginLeft:"80px", 
      borderRadius: '8px',
        [theme.breakpoints.down('sm')]: {
        marginTop:"0px",
        width:"40%", // Ensure the image fits well on smaller screens
      },
    },
    howItWorksSection: {
      padding: '50px 0',
     
    },
    sectionnTitle: {
      fontSize: '32px',
      fontWeight: 900,
      marginBottom: '20px',
      textAlign: 'center',
    },
    cardsWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 80px',
      gap: '30px',
      marginBottom: '30px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    stepCard: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '20px',
      textAlign: 'center',
      flex: 1,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: '20px',
      },
    },
    stepCardImage: {
      width: '100px',
      height: '100px',
      marginBottom: '15px',
      objectFit: 'cover',
    },
    stepCardTitle: {
      fontSize: '16px',
      fontWeight: 700,
      color: '#000',
    },
  stepIndicatorBar: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      marginTop: '30px',
      padding: '0 200px',
      [theme.breakpoints.down('sm')]: {
        marginTop: '20px',
      },
    },
    stepCircle: {
      width: '30px', 
      height: '30px',
      borderRadius: '50%', 
      border: '1px solid #AD131B',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      zIndex: 2, 
       [theme.breakpoints.down('md')]: {
        display: 'none', 
      },
    },

    
    stepCircleInner: {
      width: '15px',
      height: '15px',
      borderRadius: '50%',
      backgroundColor: '#AD131B',
       [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    progressLine: {
      width: '85%',
      position: 'absolute',
      top: '50%',
      left: '8%',
      right: '7%',
      height: '10px',
      backgroundColor: '#FFF0F0',
      color : '#FFF0F0',
      zIndex: 1, 
      transform: 'translateY(-50%)', 
       [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
})
);
const IvTherapyPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(UserContext);
  const { pathname } = useLocation();
  const handleClick = () => history.push('/urgent-care-vs-emergency-room');
   const [expanded, setExpanded] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setExpanded(expanded === index ? null : index);
  };
  const faqs = [
    {
      question: 'Is IV therapy safe? ',
      answer:
        'Yes. Our IV drips are administered by licensed medical professionals in a clinical setting, ensuring your safety and comfort. ',
    },
    {
      question: 'Do I need an appointment?',
      answer:
        ' Not at all. We welcome walk-ins for IV therapy during our normal business hours.',
    },
    {
      question: 'How quickly will I feel the effects? ',
      answer:
        ' Many patients feel relief or increased energy within minutes of completing the infusion. Full benefits often last several days. ',
    },{
      question: 'Are the medications in the pain or hangover drips safe?',
      answer:
        'Yes, all medications—like ketorolac, Zofran, and dexamethasone—are FDA-approved and administered under medical supervision. ',
    },{
      question: 'How long does an IV therapy session take? ',
      answer:'Most sessions take 30-45 minutes . You are welcome to relax in our comfortable treatment rooms during your drip. ' ,
    },
    
    // Add more questions as needed
  ];


  return (
    <main>
      {/* <Helmet>
        <title>Kenosha Urgent Care | Walk-In Clinic | Fast, Affordable Health Care</title>
        <meta
          name="description"
          content="Book your appointment online. Fast and affordable. Call us: 262-925-0535 | Visit us today: 6430 Green Bay Road, Kenosha WI 53142"
        />

        <link rel="canonical" href="/" />
      </Helmet> */}
    <Helmet>
      <title>IV Therapy in Kenosha, WI – Rehydrate, Recharge & Reclaim Wellness</title>
      <meta
        name="description"
        content="Discover fast, effective IV therapy in Kenosha with no appointment needed. Restore hydration, boost immunity, and relieve symptoms quickly with our licensed medical team. Feel better in under 45 minutes—walk in today."
      />
      <meta
        name="keywords"
        content="IV therapy Kenosha, IV infusions Wisconsin, Myers Cocktail Kenosha, IV hydration therapy, immune booster IV, beauty IV drip, migraine IV relief, hangover IV treatment, vitamin IV therapy Kenosha, wellness IV Kenosha, urgent care IV services, no appointment IV therapy, walk-in IV Kenosha, medical IV infusions, licensed IV therapy Kenosha"
      />
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "MedicalClinic",
            "name": "Kenosha Urgicare",
            "image": "https://yourdomain.com/path-to-logo.jpg",
            "@id": "https://www.kenoshaurgicare.com/iv-therapy",
            "url": "https://www.kenoshaurgicare.com/iv-therapy",
            "telephone": "+1-262-925-0535",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "3536 52nd St, Suite 2",
              "addressLocality": "Kenosha",
              "addressRegion": "WI",
              "postalCode": "53142",
              "addressCountry": "US"
            },
            "openingHours": "Mo-Su 08:00-20:00",
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 42.5883475,
              "longitude": -87.8491192
            },
            "department": {
              "@type": "MedicalSpecialty",
              "name": "IV Therapy",
              "description": "Licensed walk-in IV therapy services including Myers Cocktail, Immune Booster, Beauty Drip, and Hangover Relief."
            },
            "sameAs": [
              "https://www.facebook.com/kenoshaurgicare",
              "https://www.instagram.com/kenoshaurgicare"
            ]
          }
        `}
      </script>
    </Helmet>
      {pathname === "/" && (
        <>
          <ShowCase />
          <Banner />
        </>
      )}
      {pathname === "/login" && <LoginForm />}
      {pathname === "/signup" && <SignupForm />}

      <div className={classes.banner}>
        {/* <`img` src={Vaccine} alt={'vaccine'} style={{width:'100%', height:'auto'}}/> */}
      </div>
      {/* <Story
        imgLink={CoronaImg}
        title="Coronavirus Update & Information"
        descriptionArr={[
          `— Covid testing done for symptomatic patients only- fever, cough, body aches, loss of taste smell, etc… \n\n`,
          `— We are not a testing center—we are an urgent care. An office visit is required for ALL PATINETS getting covid testing (physician evaluation). The purpose of this is to evaluate for any potential complications caused by covid/severity of illness and fitness for work ...`,
        ]}
        link="/corona-update"
      /> */}
       <section className={classes.choseClincSection}>
        <Typography className={classes.titleIVsec}>
         IV Therapy in Kenosha, WI 
        </Typography>
        <Typography className={classes.choseClincSectionDesc}>
         Rehydrate. Recharge.
          <br />
          Reclaim Your Wellness. 
        </Typography>
       <Typography className={classes.IVDesc} >At Kenosha Urgicare, we understand that life can leave you feeling drained—whether it’s from illness, stress, travel, or simply a packed schedule. That’s why we offer targeted IV therapy drips designed to deliver essential vitamins, minerals, and medications directly into your bloodstream for fast, effective relief. </Typography>
       <Typography className={classes.IVDescBold} >Our medical-grade IV infusions are administered by licensed professionals in a safe, comfortable setting—no appointment needed. </Typography>
      </section>
     
      <section className={classes.ivTherapySection}>
        <div className={classes.ivTextSection}>
          <Typography className={classes.ivTitle}>
            What Is IV Therapy?
          </Typography>
          <Typography className={classes.ivDescription}>
            IV (intravenous) therapy is a treatment that delivers a custom blend of <span className={classes.ivImportantDescription}>hydrating fluids, vitamins, nutrients,</span> and <span className={classes.ivImportantDescription} >medications straight</span>  into your bloodstream for immediate absorption and fast results. Whether you’re seeking energy, immunity, beauty enhancement, or symptom relief, IV therapy can help you feel your best—quickly.
          </Typography>
        </div>
        <div className={classes.ivImageSection}>
          <img  src={require('../../../assets/Group.png')} alt="IV Therapy" className={classes.ivImage} />
        </div>
      </section>
      <section className={classes.sectionGradiant}>
        <Typography variant="h2" className={classes.sectionTitle}>
          Our Popular IV Therapies
        </Typography>
        <Typography className={classes.sectionSubtitle}>
          Choose the best IV therapy to recharge and boost your health.
        </Typography>
      <Typography style={{border: '1px solid #AD131B',backgroundColor:"#FFECEC" ,borderRadius:"5px" ,justifyContent:"center", padding:"12px", margin:"0 auto" , textAlign:"center" ,width:"500px" ,fontWeight:"bold",}}    >
         These services are not covered by insurance, we only accept cash payments.
        </Typography>

      {/* Card Container */}
      <section className={classes.cardContainer}>
        {/* Card 1 */}
        <div className={classes.card}>
          <img src={require('../../../assets/Myres.png')} alt="Therapy 1" className={classes.cardImage} />
          <div className={classes.cardContent}>
            <Typography variant="h6" className={classes.cardTitle}>
              Myers Mixture
            </Typography>
            <Typography className={classes.cardPrice}>$155</Typography>
            <Typography className={classes.cardDescription}>
              <span className={classes.cardSpan}>Great for:</span> Performance, Sinus Infections, Jet Lag, Fatigue
              <br />
              <span className={classes.cardSpan}> Includes:</span> Magnesium, Calcium, B-Complex, B-12, Vitamin C
            </Typography>
            <Button  onClick={() => history.push(`${user ? "/dashboard" : "/signup"}`)} className={classes.cardButton}>Book Appointment</Button>
          </div>
        </div>

        {/* Card 2 */}
        <div className={classes.card}>
          <img src={require('../../../assets/immune-booster 1.png')}alt="Therapy 2" className={classes.cardImage} />
          <div className={classes.cardContent}>
            <Typography variant="h6" className={classes.cardTitle}>
              Immune Booster
            </Typography>
            <Typography className={classes.cardPrice}>$169</Typography>
            <Typography className={classes.cardDescription}>
             <span className={classes.cardSpan}>Great for:</span> Illness Recovery, Immunity Support
              <br />
             <span className={classes.cardSpan}> Includes: </span>Magnesium, Calcium, B-Complex, B-12, Vitamin C, Zinc
            </Typography>
            <Button  onClick={() => history.push(`${user ? "/dashboard" : "/signup"}`)} className={classes.cardButton}>Book Appointment</Button>
          </div>
        </div>

        {/* Card 3 */}
          <div className={classes.card}>
          <img src={require('../../../assets/image 1 (3).png')} alt="Therapy 4" className={classes.cardImage} />
          <div className={classes.cardContent}>
            <Typography variant="h6" className={classes.cardTitle}>
Beauty Drip</Typography>
            <Typography className={classes.cardPrice}>$189</Typography>
            <Typography className={classes.cardDescription}>
              <span className={classes.cardSpan}>Great for:</span>  Skin Glow, Vitality, Anti-Aging
              <br />
             <span className={classes.cardSpan}> Includes: </span> Magnesium, Calcium, B-Complex, B-12, Vitamin C, Glutamine
            </Typography>
            <Button className={classes.cardButton}>Book Appointment</Button>
          </div>
        </div>
   
        {/* Card 4 */}
           <div className={classes.card}>
          <img src={require('../../../assets/image 2 (1).png')} alt="Therapy 3" className={classes.cardImage} />
          <div className={classes.cardContent}>
            <Typography variant="h6" className={classes.cardTitle}>
              Migraine & Pain Relief
            </Typography>
            <Typography className={classes.cardPrice}>$220</Typography>
            <Typography className={classes.cardDescription}>
               <span className={classes.cardSpan}>Great for:</span>  Migraines, Chronic Pain, Acute Discomfort
              <br />
              <span className={classes.cardSpan}> Includes: </span> Magnesium Chloride, Calcium Chloride, B-Complex, B-12, Vitamin C
            </Typography>
            <Button  onClick={() => history.push(`${user ? "/dashboard" : "/signup"}`)} className={classes.cardButton}>Book Appointment</Button>
          </div>
        </div>


        {/* Card 5 */}
        <div className={classes.card}>
          <img src={require('../../../assets/image 3 (1).png')} alt="Therapy 5" className={classes.cardImage} />
          <div className={classes.cardContent}>
            <Typography variant="h6" className={classes.cardTitle}>
              Hangover Relief
            </Typography>
            <Typography className={classes.cardPrice}>$150-$200</Typography>
            <Typography className={classes.cardDescription}>
             <span className={classes.cardSpan}>Great for:</span>  Dehydration, Nausea, Headaches
              <br />
              <span className={classes.cardSpan}> Includes: </span> Magnesium, Calcium, B-Complex, Vitamin C IV Push Meds: Ketorolac, Zofran, Dexamethasone
            </Typography>
            <Button  onClick={() => history.push(`${user ? "/dashboard" : "/signup"}`)} className={classes.cardButton}>Book Appointment</Button>
          </div>
        </div>
      </section>
      <section className={classes.section}>
        <div className={classes.sectionContent}>
          {/* Left Column */}
          <div className={classes.leftColumn}>
            <Typography className={classes.secTitle}>What Is IV Therapy?</Typography>
            <ul className={classes.description}>
              <li>Certified Medical Staff – Administered by trained, licensed professionals</li>
              <li>No Appointment Needed – Convenient walk-in availability</li>
              <li>Targeted Formulas – Blends designed for your specific needs</li>
              <li>Fast & Effective – Most treatments completed in under 45 minutes</li>
              <li>Safe, Clinical Environment – Clean, comfortable, and overseen by experienced providers</li>
            </ul>
          </div>

          {/* Right Column with Image */}
          <div className={classes.rightColumn}>
            <img src={require('../../../assets/Frame.png')} alt="IV Therapy" className={classes.image} />
          </div>
        </div>
      </section>
      </section>
       <section className={classes.howItWorksSection}>
      {/* Title */}
      <Typography className={classes.sectionnTitle}>How It Works</Typography>

      {/* Cards Wrapper */}
      <div className={classes.cardsWrapper}>
        {/* Step 1 */}
        <div className={classes.stepCard}>
          <img src={require('../../../assets/image 5.png')} alt="Step 1" className={classes.stepCardImage} />
          <Typography className={classes.stepCardTitle}>Walk In or Inquire at the Front Desk </Typography>
        </div>

        {/* Step 2 */}
        <div className={classes.stepCard}>
          <img src={require('../../../assets/image 4.png')} alt="Step 2" className={classes.stepCardImage} />
          <Typography className={classes.stepCardTitle}>Receive a Brief Medical Evaluation 
</Typography>
        </div>

        {/* Step 3 */}
        <div className={classes.stepCard}>
          <img src={require('../../../assets/image 6.png')} alt="Step 3" className={classes.stepCardImage} />
          <Typography className={classes.stepCardTitle}>Relax While Your Customized IV Drip Is Administered</Typography>
        </div>

        {/* Step 4 */}
        <div className={classes.stepCard}>
          <img src={require('../../../assets/image 7.png')} alt="Step 4" className={classes.stepCardImage} />
          <Typography className={classes.stepCardTitle}>Leave Feeling Rehydrated, Rejuvenated & Restored </Typography>
        </div>
      </div>

      <div className={classes.stepIndicatorBar}>
  <div className={classes.stepCircle}>
    <div className={classes.stepCircleInner}></div>
  </div>
  <div className={classes.stepCircle}>
    <div className={classes.stepCircleInner}></div>
  </div>
  <div className={classes.stepCircle}>
    <div className={classes.stepCircleInner}></div>
  </div>
  <div className={classes.stepCircle}>
    <div className={classes.stepCircleInner}></div>
  </div>
   <div className={classes.progressLine}></div>
</div>

      
    </section>
    <section className={classes.faqSection}>
        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid item xs={12} sm={6}>
            <Typography  className={classes.faqSubTitle}>Frequently Asked Questions</Typography>
            <Typography  className={classes.faqTitle}>FAQs – IV Therapy at Kenosha Urgicare</Typography>
            <Typography variant="body1" style={{ marginTop: '20px' ,color:"#475467"}}>
              Everything you need to know about us. Can’t find the information you’re looking for? Check our FAQs below.
            </Typography>
          </Grid>

          {/* Right Column with Questions */}
          <Grid item xs={12} sm={6}>
            {faqs.map((faq, index) => (
              <div key={index}>
                <div
                  className={`${classes.questionWrapper} ${expanded === index ? classes.expandedQuestion : ''}`} 
                  onClick={() => handleToggle(index)} 
                >
                  <Typography variant="h6" style={{ flex: 1 ,margin:"5px 5px" ,fontWeight: 600}}>
                    {faq.question}
                  </Typography>
                  <IconButton>
                    {expanded === index ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </div>

                {expanded === index && (
                  <Typography variant="body2" className={classes.answerText}>
                    {faq.answer}
                  </Typography>
                )}
              </div>
            ))}
          </Grid>
        </Grid>
      </section>

       <section className={classes.FeelBetterSection}>
        
        <Typography className={classes.choseClincSectionDesc}>
        Feel Better—Faster with IV Therapy 
        </Typography>
       <Typography className={classes.IVDesc} >Whether you need to recover from an illness, beat burnout, or simply feel more vibrant, our IV therapy drips at Kenosha Urgicare offer a fast and reliable solution. </Typography>
       <Typography className={classes.IVDescBold} >Stop by today or call us to learn more—no appointment necessary.  </Typography>
        <Button  onClick={() => history.push(`${user ? "/dashboard" : "/signup"}`)} className={classes.cardButton}>Book iv therapy session</Button>
      </section>
    </main>
  );
};

export default IvTherapyPage;
